import styled from 'styled-components';
import { IToken, IStyledProps } from 'store/ducks/globalTypes';
import CustomIconButton from '../CustomIconButton';

export const StyledButtonSection = styled('div')<IToken>`
  display: flex;
  flex-direction: column;
  margin-left: ${(props) => `${props.token.marginSM}px`};
`;

export const TextAreaElementsContainer = styled('div')`
  display: flex;
  padding: 0 !important;
`;

export const StyledCustomIconButton = styled(CustomIconButton)<IStyledProps>`
  margin-top: ${(props) => `${props.token.marginXXS}px`};

  ${(props) =>
    props.scheme === 'deepNavyTheme' &&
    `
    /* Force white color for delete icons in deep navy theme */
    .anticon-delete,
    .anticon {
      color: #FFFFFF !important;
    }
    
    /* Additional targeting for Ant Design button icons */
    &.ant-btn .anticon,
    &.ant-btn-circle .anticon,
    &.ant-btn-primary .anticon {
      color: #FFFFFF !important;
    }
    
    /* Force white for SVG icons */
    svg {
      color: #FFFFFF !important;
      fill: #FFFFFF !important;
    }
  `}
`;
